var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"text-center",attrs:{"fluid":""}},[_c('h1',[_vm._v("Generacion masiva de API (Análisis Predial Integral)")]),_c('api-manager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }